import { useState } from 'react';
import GridReport from '../../../components/gridReport/GridReport';
import { languageElements } from "./InvoicesGrid-languageElements";
import LanguageElementsHandler from '../../../repository/languageElementsHandler/LanguageElementsHandler';
import { getReportParams } from "./InvoicesGrid-params";
import DownloadFileSelector from '../../forms/downloadFilesSelector/DownloadFilesSelector';
import useMain from '../../../common/MainContext';
import SimpleModal from '../../modals/simpleModal/SimpleModal';

export default function InvoicesGrid(props) {
    const { language } = useMain();

    const languageElementsHandler = new LanguageElementsHandler(languageElements, language);
    const modalNotVisible = {
        show: false,
        buttons: [],
    }
    const [modalParams, setModalParams] = useState(modalNotVisible);

    const reportParams = getReportParams({
        cellFunctions: {
            onDownload: (id) => {
                debugger
                setModalParams({
                    show: true,
                    closeButton: true,
                    fullscreen: true,
                    title: languageElementsHandler.get('modal-download-title'),
                    body: <DownloadFileSelector
                        collection='GET_FILE_LIST_INV'
                        parentRecordId={id}
                        onClose={() => { setModalParams(modalNotVisible) }}
                    />,
                    callback: () => {
                        setModalParams(modalNotVisible)
                    },
                    buttons: [],
                })
            },
        }
    });

    return (
        <div className="invoices-grid fullpage">
            <SimpleModal
                show={modalParams.show}
                closeButton={modalParams.closeButton}
                fullscreen={modalParams.fullscreen}
                size={modalParams.size}
                title={modalParams.title}
                body={modalParams.body}
                buttons={modalParams.buttons}
                callback={(buttonId, params) => { modalParams.callback(buttonId, params) }}
            />

            <GridReport
                id='invoices'
                refreshId={props.refreshId || 0}
                dataEndpoint={`${process.env.REACT_APP_API_BASE_URL}/data`}
                report={{
                    collection: 'INVOICES',
                    reportParams,
                    languageElements,
                }}
            />
        </div>
    );
}
